module.exports = __webpack_public_path__ + "img/img_dmain7.bd3becbe.jpg";